<template>
	<div>
		<v-snackbar
			v-model="snackbar"
			:timeout="10000"
			:top="true"
			color="accent"
			class="black--text"
		>
			{{ snackbarText }}
			<v-btn class="blexon-button" small icon @click="snackbar = false">
				<v-icon>close</v-icon>
			</v-btn>
		</v-snackbar>
		<v-form v-model="formValid" ref="form">
			<v-container class="content" fluid>
				<v-layout column>
					<v-flex>
						<h1 class="display-1">Klebeband bestellen</h1>
					</v-flex>
					<v-flex>
						<p class="mb-0">
							Hier kann Blexon Klebeband bestellt werden.<br />
							Bitte geben Sie den Namen des Bestellenden an.
						</p>
					</v-flex>
					<v-flex>
						<v-layout row align-center wrap>
							<v-flex xs12 md6 lg3 class="pa-2">
								<v-text-field
									v-model="prename"
									label="Vorname"
									autocomplete="shut-up-google"
									:rules="rules.required"
								></v-text-field>
							</v-flex>
							<v-flex xs12 md6 lg3 class="pa-2">
								<v-text-field
									v-model="lastname"
									label="Nachname"
									autocomplete="shut-up-google"
									:rules="rules.required"
								></v-text-field>
							</v-flex>
							<v-spacer></v-spacer>
						</v-layout>
					</v-flex>

					<v-flex>
						<v-btn
							class="ma-0 blexon-button"
							:disabled="isLoading || isOrdered || !formValid"
							@click="orderTape()"
						>
							<v-progress-circular
								size="16"
								v-if="isLoading"
								indeterminate
							></v-progress-circular>
							Bestellen
						</v-btn>
					</v-flex>
					<v-flex v-if="isOrdered">
						<p style="color: green">
							Das Klebeband wurde erfolgreich bestellt.<br />
							In wenigen Tagen wird das Paket bei Ihnen eintreffen.
						</p>
					</v-flex>
				</v-layout>
			</v-container>
		</v-form>
	</div>
</template>

<script>
import httpClient from "../store/httpClient";

export default {
	data() {
		return {
			isLoading: false,
			snackbar: false,
			snackbarText: "",
			formValid: false,
			isOrdered: false,
			prename: "",
			lastname: "",
			rules: {
				required: [
					(v) => !!v || "Angabe erforderlich",
					(v) => (!!v && v.length <= 50) || "Darf nicht länger als 50 Zeichen sein",
				],
			},
		};
	},

	computed: {
		fertiger() {
			var fertigerId = this.$route.params.fertigerId;
			var currentFertiger = this.$store.state.fertiger.filter((f) => f.id == fertigerId);
			return currentFertiger[0];
		},
	},
	methods: {
		async orderTape() {
			try {
				this.isLoading = true;
				await httpClient().post(
					`api/Fertiger/OrderTape?fertigerId=${this.fertiger.id}&prename=${this.prename}&lastname=${this.lastname}`,
					null
				);
				this.setSnackbarText("Klebeband erfolgreich bestellt.");
				this.isOrdered = true;
			} catch (err) {
				this.setSnackbarText(
					"Klebeband konnte nicht bestellt werden. Bitte kontaktieren Sie Blexon."
				);
			} finally {
				this.isLoading = false;
			}
		},

		setSnackbarText(text) {
			this.snackbarText = text;
			this.snackbar = true;
		},
	},
};
</script>

<style scoped></style>
